module.exports = __webpack_public_path__ + "img/top-title.dd5fdff3.png";